/** @jsxImportSource @emotion/react */
import { memo } from "react";
import { Link } from "react-router-dom";

// CSS読み込み
import {
  linkWrap,
  linkText,
  linkFlexWrap,
  backToInputLinkIcon,
} from "assets/css/stylesCss";

/**
 * 入力に戻るリンク
 * @prop {String} path ジャンプ先ページのパス
 * childrenには要素内の文字列が自動的に入る
 */
const BackToInputLink = memo(({ path, children }) => {
  return (
    <div css={linkWrap}>
      <Link css={linkText} to={{ pathname: path }} state={{ isSubmit: true }}>
        <div css={linkFlexWrap}>
          <span css={backToInputLinkIcon}>{children}</span>
        </div>
      </Link>
    </div>
  );
});

export default BackToInputLink;
